import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-login-layout',
    template: `
    <p>
      login-layout works!
    </p>
  `,
    styles: [],
    standalone: false
})
export class LoginLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
